<template>
  <!-- <div class="errPage-container">
        <img src="../../assets/images/bgNoData.png"/>
        <div class="errPage-error">
            请联系管理员，开通权限！！！
        </div>
  </div>-->
  <div class="errPage-container">
    <el-row>
      <el-col :span="12">
        <h1 class="text-jumbo text-ginormous">Oops!</h1>
        <h2>你没有权限访问该系统</h2>
        <h6>如有问题请联系你领导</h6>
        <ul class="list-unstyled">
          <li>或者你可以去:</li>
          <li class="link-type">
            <a href="https://www.taobao.com/">随便看看</a>
          </li>
          <li>
            <a href="#" @click.prevent="dialogVisible=true">点我看图</a>
          </li>
        </ul>
      </el-col>
      <el-col :span="12">
        <img :src="errGif" width="313" height="428" alt="Girl has dropped her ice cream." />
      </el-col>
    </el-row>
    <el-dialog :visible.sync="dialogVisible" title="随便看">
      <img :src="ewizardClap" class="pan-img" />
    </el-dialog>
  </div>
</template>

<script>
/**
 * 403 无权限提示页
 * 功能：提示"你没有权限访问该系统"，含随便看看/点我看图入口。
 * 备注：组件 name 为 "Page401"，为 401 页复制残留（组件名与 401 页相同）；back() 定义未使用（死代码）。
 */
import errGif from "@/assets/401_images/401.gif";
export default {
  name: "Page401",
  data() {
    return {
      // 403 提示动图（带时间戳防缓存）
      errGif: errGif + "?" + +new Date(),
      // 弹窗展示图片（外部地址）
      ewizardClap: "http://yunyi.delaman168.com:8084/images/fun.gif",
      // 图片查看弹窗显示状态
      dialogVisible: false,
    };
  },
  methods: {
    /** 返回上一页或回首页（疑似死代码：模板中未使用） */
    back() {
      if (this.$route.query.noGoBack) {
        this.$router.push({ path: "/dashboard" });
      } else {
        this.$router.go(-1);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
ul li {
  list-style-type: none;
}
.errPage-container {
  width: 800px;
  max-width: 100%;
  margin: 100px auto;
  .pan-back-btn {
    background: #008489;
    color: #fff;
    border: none !important;
  }
  .pan-gif {
    margin: 0 auto;
    display: block;
  }
  .pan-img {
    display: block;
    margin: 0 auto;
    width: 100%;
  }
  .text-jumbo {
    font-size: 60px;
    font-weight: 700;
    color: #484848;
  }
  .list-unstyled {
    font-size: 14px;
    li {
      padding-bottom: 5px;
    }
    a {
      color: #008489;
      text-decoration: none;
      &:hover {
        text-decoration: underline;
      }
    }
  }
}
</style>

